/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable import/extensions */
import React, { useEffect, useState } from 'react';
import '@react-awesome-query-builder/antd/css/styles.css';
import TextArea from 'antd/lib/input/TextArea';
import SQLQueryBuilder from './sqlQueryBuilder';
import dummyJson from './dummy';
import InterfaceSqlBuilderConfig from './sqlQueryBuilder/interfaces/InterfaceSqlBuilderConfig';
import SQL_QUERY_BUILDER_CONSTANT from './sqlQueryBuilder/constant/SQL_QUERY_BUILDER_CONSTANT';

interface QueryBuilderProps {
  label?: string;
  configFields?: InterfaceSqlBuilderConfig;
  queryValue?: any;
  setExpression?: any;
  expressionValue?: any;
  queryResult?: boolean;
  handleOnQueryChange?: any
  showButtons?:boolean,
  editFormula?:boolean,
  showEditor?:boolean
  handleEditMode?:any
}

const QueryBuilder: React.FC<QueryBuilderProps> = ({
  label,
  configFields,
  queryValue,
  setExpression,
  expressionValue,
  queryResult,
  handleOnQueryChange,
  showButtons,
  editFormula,
  showEditor,
  handleEditMode
}) => {
  const [sqlValue, setSqlValue] = useState(queryValue || '');
  const [value, setValue] = useState(dummyJson);
  const [internalConfig, setInternalConfig] = useState<InterfaceSqlBuilderConfig>({
    mode: SQL_QUERY_BUILDER_CONSTANT.MODE.SINGLE,
    columns: [
      {
        name: 'FINAL_RESOLUTION',
        dataType: 'string',
        columnType: 'master',
        master: ['NORM', 'RB'],
      },
      {
        name: 'BOM_BKT',
        dataType: 'string',
        columnType: 'master',
        master: ['0', 'X', '1', '2', '3'],
      },
      {
        name: 'PV_FINAL_PRODUCT_NEW',
        dataType: 'string',
        columnType: 'master',
        master: ['PL', 'BL', 'MBL', 'CCOD_PL', 'CCOD_BL'],
      },
      { name: 'POS', dataType: 'number', columnType: 'normal' },
    ],
  });
  const onSave = (data: any) => {
    setSqlValue(data.sql);
    setValue(data.json);
    if (setExpression) {
      setExpression(data.json);
    }
  };

  useEffect(() => {
    if (configFields?.columns?.length > 0) {
      const updatedColumns = configFields.columns.map((column) => {
        if (column.dataType === 'decimal') {
          return { ...column, dataType: 'number' };
        }
        return column;
      });
      setInternalConfig({ ...configFields, columns: updatedColumns });
    }
  }, [configFields]);

  return (
    <div>
      <SQLQueryBuilder
        label={label}
        onSave={onSave}
        handleOnQueryChange={handleOnQueryChange}
        value={expressionValue || value}
        config={internalConfig}
        showEditor={showEditor}
        showButtons={showButtons}
        editFormula={editFormula}
        handleEditMode={handleEditMode}
      />
      {queryResult ? (
        <div className="query-builder-result">
          <div>
            <TextArea value={sqlValue} rows={10} />
          </div>
          <h3>Json Logic</h3>
          <pre>{JSON.stringify(value.jsonLogic, null, 2)}</pre>
          <h3>Json</h3>
          <pre>{JSON.stringify(value, null, 2)}</pre>
        </div>
      ) : null}
    </div>
  );
};

export default QueryBuilder;
